/* eslint-disable no-param-reassign */
// import { thunk, action, computed } from 'easy-peasy'

export default {
  landing: [],
}
